<template>
  <v-dialog v-model="dialogProxy" width="914">
    <v-card>
      <v-card-title primary-title style="display: block;">
        <div class="H4-Secondary-Center">Choose GlobalMenuGroups</div>
        <div class="Body-2-Selected-On-Surface-Medium-Emphasis-Left">
          {{ getSubTitle() }}
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap justify-space-between>
          <v-flex xs12>
            <v-text-field
              label="Search GlobalMenuGroups"
              prepend-icon="mdi-magnify"
              v-model="search"
              clearable
            />
          </v-flex>
          <v-flex xs12>
            <v-layout row>
              <v-flex xs6 class="globalMenuGroup-panel" style="overflow: hidden;">
                <div class="H6-Secondary-Left">Suggested GlobalMenuGroups</div>
                <div>
                  <v-list class="global-menu-group-panel" id="global-menu-group-panel">
                    <v-list-tile @click="selectAll">
                      <v-list-tile-content>
                        <v-list-tile-title>Select All</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile
                      v-for="(globalMenuGroup, globalMenuGroupIndex) of orderBy(
                        filterBy(allGlobalMenuGroups, search, 'name'),
                        'name',
                      )"
                      @click="() => {}"
                      :key="globalMenuGroup.id"
                      :id="globalMenuGroupIndex"
                    >
                      <v-list-tile-action>
                        <v-checkbox
                          color="#4020ae"
                          v-if="isVisible(globalMenuGroupIndex)"
                          :value="globalMenuGroup.id"
                          :label="globalMenuGroup.name"
                          v-model="selectedGlobalMenuGroupsProxy"
                        />
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="H6-Secondary-Left">
                  Brand Groups Selected ({{ selectedGlobalMenuGroupsProxy.length }})
                </div>
                <div>
                  <v-list class="global-menu-group-panel">
                    <v-list-tile @click="removeAll">
                      <v-list-tile-content>
                        <v-list-tile-title>Remove All</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-list-tile
                      v-for="globalMenuGroup of orderBy(
                        filterBy(selectedGlobalMenuGroupsData, search, 'name'),
                        'name',
                      )"
                      @click="removeGlobalMenuGroup(globalMenuGroup.id)"
                      :key="globalMenuGroup.id"
                    >
                      <v-list-tile-action>
                        <v-icon>mdi-close-circle</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ globalMenuGroup.name }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="cancel()">Cancel</v-btn>
        <v-btn color="primary" flat @click="confirm()">Continue</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import filters from 'vue2-filters';
import { mapActions } from 'vuex';
import { UserRoles } from '@/constants';

export default {
  mixins: [filters.mixin],
  props: ['dialog', 'selectedGlobalMenuGroups'],
  data: () => ({
    dialogProxy: false,
    selectedGlobalMenuGroupsProxy: [],
    search: null,
    visibleAreaTop: 0,
    visibleAreaBottom: 550,
    globalMenuGroupPanelDOMNode: null,
    saveData: false,
    globalMenuGroupDOMNodeHeight: 48,
    listHeight: 450,
    offset: 200,
    UserRoles,
    globalMenuGroupMap: {},
  }),
  async mounted() {
    try {
      this.globalMenuGroupPanelDOMNode = document.getElementById('global-menu-group-panel');
      this.globalMenuGroupPanelDOMNode.addEventListener('scroll', this.handleScroll);
      await this.getGlobalMenuGroups();
    } catch (err) {
      console.error(err);
      this.$toast.error('Could not fetch CentricOS Menu Brand Groups');
    }
  },
  beforeDestroy() {
    const listPanel = document.getElementById('global-menu-group-panel');
    if (listPanel) listPanel.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    selectedGlobalMenuGroupsData() {
      return this.selectedGlobalMenuGroupsProxy.map((e) => this.globalMenuGroupMap[e]) || [];
    },
    allGlobalMenuGroups() {
      return Object.values(this.globalMenuGroupMap) || [];
    },
  },
  watch: {
    dialogProxy(d) {
      this.$emit('update:dialog', d);
      // caching everything in hashtable
      if (this.saveData) {
        const selectedGlobalMenuGroups = {};
        this.selectedGlobalMenuGroupsData.forEach((globalMenuGroup) => {
          if (this.selectedGlobalMenuGroups[globalMenuGroup.id]) {
            selectedGlobalMenuGroups[globalMenuGroup.id] = this.selectedGlobalMenuGroups[
              globalMenuGroup.id
            ];
            return;
          }
          selectedGlobalMenuGroups[globalMenuGroup.id] = globalMenuGroup;
          selectedGlobalMenuGroups[globalMenuGroup.id].isAllSelected = true;
          if (globalMenuGroup.brands) {
            Object.keys(globalMenuGroup.brands).forEach((brandId) => {
              globalMenuGroup.brands[brandId].isSelected = true;
            });
          }
        });
        this.$emit('update:selectedGlobalMenuGroups', selectedGlobalMenuGroups);
      }
      this.saveData = false;
    },
    dialog(value) {
      this.$set(this, 'dialogProxy', value);
      // converting hashtable into array
      const selectedGlobalMenuGroups = Object.keys(this.selectedGlobalMenuGroups) || [];
      this.$set(this, 'selectedGlobalMenuGroupsProxy', selectedGlobalMenuGroups);
    },
  },
  methods: {
    ...mapActions('centricOSMenu', ['getMenuGlobalMenuGroups']),
    async getGlobalMenuGroups() {
      const results = await this.getMenuGlobalMenuGroups({
        relationships: '["draft_brands"]',
      });
      this.globalMenuGroupMap = results
        .map((group) => ({
          ...group,
          brands: group.draft_brands.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {}),
        }))
        .reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {});
    },
    cancel() {
      this.dialogProxy = false;
      this.selectedGlobalMenuGroupsProxy = Object.keys(this.selectedGlobalMenuGroups) || [];
    },
    confirm() {
      // Have to do this check because radio buttons model the data as a string since only 1 can be selcted
      if (typeof this.selectedGlobalMenuGroupsProxy === 'string') {
        this.selectedGlobalMenuGroupsProxy = [this.selectedGlobalMenuGroupsProxy];
      }
      this.saveData = true;
      this.dialogProxy = false;
    },
    removeGlobalMenuGroup(id) {
      this.selectedGlobalMenuGroupsProxy.splice(this.selectedGlobalMenuGroupsProxy.indexOf(id), 1);
    },
    selectAll() {
      this.search = null;
      this.$set(this, 'selectedGlobalMenuGroupsProxy', Object.keys(this.globalMenuGroupMap));
    },
    removeAll() {
      this.selectedGlobalMenuGroupsProxy = [];
    },
    handleScroll() {
      this.visibleAreaTop = this.globalMenuGroupPanelDOMNode.scrollTop - this.offset;
      this.visibleAreaBottom = this.visibleAreaTop + this.listHeight + this.offset;
    },
    isVisible(i) {
      return (
        (i + 1) * this.globalMenuGroupDOMNodeHeight >= this.visibleAreaTop &&
        (i + 1) * this.globalMenuGroupDOMNodeHeight <= this.visibleAreaBottom
      );
    },
    getSubTitle() {
      return 'Select global menu groups to edit brand permissions.';
    },
  },
};
</script>

<style>
.globalMenuGroup-panel {
  min-width: 300px;
}
.global-menu-group-panel {
  height: 50vh;
  overflow: scroll;
  border: solid 1px #757575;
  margin-right: 5px;
  margin-top: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
